"use strict";
exports.__esModule = true;
exports.dereferencedSchemaPromise = exports.dereferencedSchema = exports.openapi = void 0;
var $RefParser = require("@apidevtools/json-schema-ref-parser");
exports.openapi = require("./openapi.json");
exports.dereferencedSchema = exports.openapi;
exports.dereferencedSchemaPromise = $RefParser
    .dereference(exports.openapi)
    .then(function (schema) {
    exports.dereferencedSchema = schema;
});
